import React from "react";
import {TranslationDomainEnum} from "../../../types/enums";
import {Form, Input} from "antd";
import {Translate} from "../../../components/util/translation.util";
import {EmailConstraint} from "../validation/constraints";

type Props = {
    name: string,
    label: string,
    translationDomain: TranslationDomainEnum,
    rules: any,
    onChange?: () => void,
    errors: { [key: string]: string[] },
    validateTrigger?: string,
};

export const EmailType: React.FC<Props> = ({ name, label, translationDomain, rules, onChange, errors , validateTrigger= 'onBlur'}) => {
    return (
        <Form.Item
                labelAlign={`left`}
                name={ name.split('.') }
                label={<Translate message={label} domain={translationDomain} />}
                rules={[...rules, EmailConstraint()]}
                validateTrigger={validateTrigger}
        >
            <Input type="email" onChange={onChange} />
        </Form.Item>
    )
}